import API from '@/api/index.js';
import store from '@/store';
const {api,base}=API

//作業類別
const constructionType = () => {
  return [
    {
      name: "一般作業",
      value: "一般作業",
      description: "申請施工開始時間為當日-9日",
    },
    {
      name: "特殊作業",
      value: "特殊作業",
      description: "申請施工開始時間為當日-9日",
    },
  ]
}

//get部門員工
const getDepartmentEmployee = () => {
  return api.admin.email().then(res => {
    return res.data
  })
}

//get承攬商員工
const getVenderEmployee = (id) => {
  if(id){
    return api.admin.venderEmployee(id).then(res => {
      return res.data
    })
  }else{
    return api.admin.venderEmployee(store.state.user.id).then(res => {
      return res.data
    })
  }

}

//get作業區域
const getArea = () => {
  return api.admin.location().then(res => {
    return res.data
  })
}

//get承攬商
const getVendor = () => {
  return api.admin.vendorList().then((res) => {
    return res.data
  });
}

//get特殊作業
const getSpecialOperation = () => {
  return api.admin.specialOperation().then((res) => {
    return res.data
  });
}

//get部門清單
const getDepartment = () => {
  return api.admin.department().then((res) => {
    return res.data
  });
}

export default {
  getDepartmentEmployee,
  getVenderEmployee,
  getArea,
  getVendor,
  getSpecialOperation,
  constructionType,
  getDepartment,
}